export default "__VITE_ASSET__BRzI395c__"